<div *ngIf="package" class="package-body card" [ngClass]="getGeneralClass()" (dragstart)="onDragStart($event)"
    (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" [draggable]="isDraggable"
    (click)="onClickCard($event)">
    <div class="infopackage">
        <div class="package">
            <div class="prompt">{{ 'TRUCKING.SHIPMENT.BULTO.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="package.packageKey" class="packageKey"
                [value]="package.packageKey">{{package.packageKey}}
            </shared-copyclipboard>
        </div>
        <div class="package" *ngIf="package.customerReference">
            <div class="prompt">{{ 'TRUCKING.SHIPMENT.CUSTOMERREFERENCE.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="package.customerReference" class="packageKey"
                [value]="package.customerReference">{{package.customerReference}}
            </shared-copyclipboard>
        </div>
    </div>
    <div class="deliveryLines">
        <div class="prompt">{{ 'TRUCKING.SHIPMENT.DELIVERYLINES.CAPTION' | translate}}</div>
        <table>
            <tr class="header">
                <td>{{ 'TRUCKING.SHIPMENT.QUANTITY.CAPTION' | translate}}</td>
                <td>{{ 'TRUCKING.SHIPMENT.REFERENCE.CAPTION' | translate}}</td>
                <td>{{ 'TRUCKING.SHIPMENT.DESCRIPTION.CAPTION' | translate}}</td>
            </tr>
            <tr *ngFor="let line of package.lines" class="line">
                <td class="quantity">{{ line.quantityProduct}}</td>
                <td class="reference">{{ line.referenceProduct}}</td>
                <td class="description">{{ line.descriptionProduct}}</td>
            </tr>
        </table>
    </div>

    <div class="bottom-zone">
        <i *ngIf="package.isTruckedPackage" class="fa fa-truck" aria-hidden="true"></i>

        <div class="block-route-card-info-count">
            <span class="route-card-info-count">{{getResourcePalletCount()}} {{
                getResourcePalletType() | translate }}</span>
        </div>

        <ng-container *ngIf="packageDetail">
            <div class="block-route-card-info-count kilos"
                matTooltip="{{ 'ROUTECARD.KILOSCOUNT.TOOLTIP' | translate: {value: packageDetail.kg} }}">
                <div class="heading"> <i class="hardman-kg icon"></i>
                    <span class="caption">{{ 'ROUTECARD.KILOSCOUNT.CAPTION' | translate}}</span>
                </div>
                <div class="route-card-info-count">
                    {{ packageDetail.kg }}
                </div>
            </div>
            <div class="block-route-card-info-count xDimension"
                matTooltip="{{ 'ROUTECARD.XDIMENSION.TOOLTIP' | translate: {value: packageDetail.xDimension} }}">
                <div class="heading">
                    <span class="caption">{{ 'ROUTECARD.XDIMENSION.CAPTION' | translate}}</span>
                </div>
                <div class="route-card-info-count">
                    {{ packageDetail.xDimension}}
                </div>
            </div>
            <div class="block-route-card-info-count yDimension"
                matTooltip="{{ 'ROUTECARD.YDIMENSION.TOOLTIP' | translate: {value: packageDetail.yDimension} }}">
                <div class="heading">
                    <span class="caption">{{ 'ROUTECARD.YDIMENSION.CAPTION' | translate}}</span>
                </div>
                <div class="route-card-info-count">
                    {{ packageDetail.yDimension }}
                </div>
            </div>
            <div class="block-route-card-info-count zdimension"
                matTooltip="{{ 'ROUTECARD.ZDIMENSION.TOOLTIP' | translate: {value: packageDetail.zDimension} }}">
                <div class="heading">
                    <span class="caption">{{ 'ROUTECARD.ZDIMENSION.CAPTION' | translate}}</span>
                </div>
                <div class="route-card-info-count">
                    {{ packageDetail.zDimension }}
                </div>
            </div>
        </ng-container>

        <div class="action-buttons">
            <button-link class="info-button color-unset" variant="forward" *ngIf="!package.showDetail"
                (linkClick)="onShowDetailClick()"><i class="fa fa-info-circle" aria-hidden="true"></i></button-link>
            <button *ngIf="showButtonPut && (package.showDetail || !inShipmentCard)" class="action confirmButton"
                (click)="onPutPackageClick()">{{ 'TRUCKING.SHIPMENT.ACTIONS.PUTPACKAGE.CAPTION' |
                translate}}</button>
            <button *ngIf="showButtonRemove" class="action deleteButton" (click)="onRemovePackageClick()">{{
                'TRUCKING.SHIPMENT.ACTIONS.REMOVEPACKAGE.CAPTION' | translate}}</button>
        </div>
    </div>
</div>